export enum OrderTypes {
  CUSTOM = 'custom',
  SINGLE = 'single',
}

export enum ProductTypes {
  TYPES_BOWL = 35,
  ADITIONS = 36,
}

export enum OrderHistory {
  ROOT = 'orders',
  OPEN = 'open_orders',
  CLOSED = 'closed_orders',
}
